import React, { useId } from "react";
import { DatasetBarChartProps } from "components/dashboard/charts/interfaces";
import ChartWrapper from "components/dashboard/charts/chart-wrapper/ChartWrapper";
import DatasetBarChart from "components/dashboard/charts/bar-chart/DatasetBarChart";
import { APIResponseToDatasetDataInfoResponseArray } from "components/dashboard/charts/bar-chart/DatasetBarChartDataConverter";
import Plotly from "plotly.js";
import { clipboardIcon } from "../icons";
import copyChartToClipBoard from "../chartUtils";

const DatasetBarChartRenderer = (props: DatasetBarChartProps) => {
  const uniqueId = useId();

  const chartConfig: Partial<Plotly.Config> = {
    displaylogo: false,
    modeBarButtonsToRemove: ["lasso2d", "select2d"],
    modeBarButtonsToAdd: [
      {
        title: "Copy chart to Clipboard",
        name: "Copy chart to Clipboard",
        icon: clipboardIcon,
        click: copyChartToClipBoard,
      },
    ],
  };

  const identifiers = props.datasets?.map((dataset) => dataset.identifier);
  const datasetOptions = props.datasets?.map((dataset) => ({
    identifier: dataset.identifier,
    color: dataset.color,
    overriddenTitle: dataset.overriddenTitle,
  }));

  const promiseHandler = (res: any) =>
    APIResponseToDatasetDataInfoResponseArray(res, datasetOptions || []);

  return (
    <ChartWrapper
      uniqueKey={uniqueId}
      identifiers={identifiers || props.identifiers}
      showDateSelection
      promiseHandler={promiseHandler}
      updateFrequency={props.updateFrequency}
      loadConf={props.loadConf}
      hideRefresh={props.hideRefresh}
      dynamicHeight={props.dynamicHeight}
      referenceTime={props.referenceTime}
      datasetChart="bar"
      chartConfig={chartConfig}
      width={props.width}
      reportMode={props.reportMode}
    >
      {(wrapper: any) => (
        <div>
          <DatasetBarChart
            data={wrapper.data}
            width={wrapper.width}
            height={wrapper.height}
            dateFormat={props.dateFormat}
            chartConfig={wrapper.chartConfig}
          />
        </div>
      )}
    </ChartWrapper>
  );
};

export default DatasetBarChartRenderer;
